import type { ReactNode } from "react";
import FlatSelectMulti from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/display-options/menu/flat-select-multi/FlatSelectMulti.tsx";
import useDisplayTogglesController from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/display-options/menu/display-toggles/useDisplayTogglesController.ts";

export default function DisplayToggles(): ReactNode {
  const controller = useDisplayTogglesController();
  return (
    <FlatSelectMulti
      title={controller.title}
      items={controller.items}
      isSelectedItem={controller.isSelectedItem}
      onSelectItem={controller.toggleItem}
      showSelectAll={false}
      folded={controller.folded}
      onFoldedChanged={controller.setFolded}
    />
  );
}
